import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ContentHeaderKey } from 'src/app/constants/content-header';
import { BenefitSummaryList } from 'src/app/models/benefit-summary';
import { InPageNavItem } from 'src/app/models/in-page-nav';
import { Member } from 'src/app/models/member';
import { DashboardPayCheckModel } from 'src/app/models/payroll';
import { PayrollDashboardModel } from 'src/app/models/payroll-dashboard-model';
import { NavigationService } from 'src/app/services/navigation.service';
import { PayrollService } from 'src/app/services/payroll.service';
import { SessionService } from 'src/app/services/storage/session.service';

@Component({
    selector: 'mwp-payroll-dashboard',
    templateUrl: 'payroll-dashboard.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PayrollDashboardComponent implements OnInit {
    public apiUrl = ContentHeaderKey.PayrollDashboard;
    public member: Member;
    public navItems: InPageNavItem[];
    public currentBenefits: BenefitSummaryList;
    public dashboardPayCheckModel: DashboardPayCheckModel;
    public boxOneLabel: string;
    public boxOneValue: string;
    public boxTwoLabel: string;
    public boxTwoValue: string;
    public isLoaded: boolean = false;


    constructor(
        private payrollService: PayrollService,
        private navService: NavigationService,
        private sessionService: SessionService,
        private router: Router

    ) {
        this.navItems = this.navService.buildMemberPageNavItems(this.router.url);
    }

    ngOnInit(): void {
        this.getPayrollDashboard();
        this.boxOneLabel = "AVAILABLE PTO";
        this.boxOneValue = this.sessionService.session.member.availablePTO;
        this.boxTwoLabel = "AVAILABLE SICK TIME";
        this.boxTwoValue = this.sessionService.session.member.availableSickTime;
    }

    private getPayrollDashboard(): void {
        this.payrollService.getPayrollDashboard().subscribe((response: PayrollDashboardModel) => {
            this.member = response.myProfileModel;
            this.currentBenefits = response.genericBenefitSummaryModel;
            this.dashboardPayCheckModel = response.payCheck;
            this.isLoaded = true;
        });
    }
}